var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "pr-3 pt-3 pb-0", class: _vm.className },
    [
      _c(
        "v-toolbar",
        {
          staticClass: "app-header gray--text",
          attrs: { color: "white", tabs: "", flat: "" },
        },
        [
          _c("h1", { staticClass: "title", attrs: { title: _vm.title } }, [
            _vm._v("\n      " + _vm._s(_vm.title) + "\n    "),
          ]),
          _vm._v(" "),
          _c("v-spacer"),
          _vm._v(" "),
          _vm.backButton
            ? _c(
                "v-btn",
                {
                  attrs: { flat: "", color: "secondary" },
                  on: { click: _vm.back },
                },
                [_vm._v("\n      Voltar\n    ")]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.options.length
            ? _c(
                "v-menu",
                {
                  attrs: {
                    origin: "center center",
                    transition: "scale-transition",
                    bottom: "",
                    left: "",
                  },
                },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: { slot: "activator", icon: "" },
                      slot: "activator",
                    },
                    [
                      _c("v-icon", { staticClass: "gray--text darken-4" }, [
                        _vm._v("\n          more_vert\n        "),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-list",
                    _vm._l(
                      _vm.options.filter(
                        ({ show }) => show === undefined || !!show
                      ),
                      function (option, index) {
                        return _c(
                          "v-list-tile",
                          {
                            key: index,
                            attrs: { disabled: option.disabled },
                            on: {
                              click: function ($event) {
                                return _vm.emit(option.method)
                              },
                            },
                          },
                          [
                            _c("v-list-tile-title", [
                              _vm._v(_vm._s(option.title)),
                            ]),
                          ],
                          1
                        )
                      }
                    ),
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "v-tabs",
            {
              attrs: {
                slot: "extension",
                value: _vm.activeTab,
                "show-arrows": "",
              },
              slot: "extension",
            },
            [
              _c("v-tabs-slider", { attrs: { color: "secondary" } }),
              _vm._v(" "),
              _vm._l(_vm.onItems, function (item, index) {
                return _c(
                  "v-tab",
                  {
                    key: index,
                    nativeOn: {
                      "!click": function ($event) {
                        $event.preventDefault()
                        $event.stopPropagation()
                        return _vm.onSelect(item)
                      },
                    },
                  },
                  [_vm._v("\n        " + _vm._s(item.title) + "\n      ")]
                )
              }),
            ],
            2
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }